import { Outlet } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollManager from '@/components/feature/ScrollManager';
import BackToTop from '@/components/feature/BackToTop';

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <ScrollManager />
      <SiteHeader />
      <div className="flex-1">
        <Outlet />
      </div>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}